__webpack_require__.p = "https://mfe.au.autoguru.com/de-portal-app-shell/";